class MessagePopup {
  constructor({
    log,
    element
  }) {
    this.log      = log.forClass("MessagePopup")
    this.element  = element
  }

  place({ viewportCenterX, viewportCenterY }) {
    const logger = this.log.method("place", { viewportCenterX, viewportCenterY })
    this.element.style["display"] = "block"
    logger.addDetails({offsetWidth: this.element.offsetWidth, offsetHeight: this.element.offsetHeight })
    this.element.style.left = `${viewportCenterX - (this.element.offsetWidth / 2)}px`
    this.element.style.top  = `${viewportCenterY - (this.element.offsetHeight / 2)}px`
    logger.end({ left: this.element.style.left, top: this.element.style.top })
  }

  hide() {
    const alreadyHidden = this.element.style["display"] === "none"
    this.element.style["display"] = "none"
    if (alreadyHidden) {
      return true
    }
    else {
      return false
    }
  }

  render(game, change) {
    const logger = this.log.method("render", { change })

    let message = change.messageObject()

    if (message && message.message && message.message.length > 0 && !message.hide) {
      const $messageText = this.element.querySelector("[data-message-text]")
      const $messageIcon = this.element.querySelector("[data-message-icon]")
      const $messageName = this.element.querySelector("[data-message-name]")
      $messageText.innerText = message.message
      $messageIcon.className = `tile ${message.css_class}`
      if (message.character_name) {
        $messageName.innerText = message.character_name
      }
      else {
        $messageName.innerText = ""
      }
      this.element.style.display = "block"
    }
    else {
      logger.addDetails({ unexpectedMessage: message })
    }
    logger.end()
  }
}

export default MessagePopup
